import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import axios from "axios";

const PopupComponent2 = (props) => {
  const [showPopup, setShowPopup] = useState(props.isPopupOpen);
  const [rowCount, setRowCount] = useState(1);
  const [machineName, setMachineName] = useState("");
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const [type, setType] = useState("");
  const [selectedOrigin, setSelectedOrigin] = useState("");
  const [description, setDescription] = useState("");
  const [Servicerequestformdata, setContactnamedata] = useState("");
  const [isVisible, setIsVisible] = useState("Web");
  const [assignedEngineerId, setAssignedEngineerId] = useState("");
  const [formData, setFormData] = useState([
    { partNo: "", qty: "", description: "" },
  ]);
  const [errors, setErrors] = useState({
    partNo: [],
    qty: [],
    description: [],
  });
  const [assignedEngineer, setAssignedEngineer] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [partNumbersList, setPartNumbersList] = useState([]);
  const [openPartDropdownIndex, setOpenPartDropdownIndex] = useState(null);
  const partDropdownWrapperRefs = useRef([]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      partNo: [],
      qty: [],
      description: [],
    };

    if (!type) {
      isValid = false;
    }

    if (!description) {
      isValid = false;
    }

    if (
      type === "Part(s) Exchange" ||
      type === "Part(s) / Consumable Request"
    ) {
      formData.forEach((part, index) => {
        if (!part.partNo) {
          isValid = false;
          newErrors.partNo[index] = "Part No. is required";
        }
        if (!part.qty) {
          isValid = false;
          newErrors.qty[index] = "Qty is required";
        }
        if (!part.description) {
          isValid = false;
          newErrors.description[index] = "Description is required";
        }
      });
    }

    setErrors(newErrors);
    return isValid;
  };

  const email = sessionStorage.getItem("email");
  const machineId = sessionStorage.getItem("machineId");

  const handleContactsChange = (selectedOptions) => {
    setSelectedContacts(selectedOptions);
  };

  const handleAddRow = () => {
    setFormData([...formData, { partNo: "", qty: "", description: "" }]);
    setRowCount(rowCount + 1);
  };

  const handleChange = (index, field, value) => {
    const updatedFormData = [...formData];
    updatedFormData[index][field] = value;
    setFormData(updatedFormData);

    const updatedErrors = { ...errors };
    if (field === "partNo" && value) updatedErrors.partNo[index] = "";
    if (field === "qty" && value > 0) updatedErrors.qty[index] = "";
    if (field === "description" && value) updatedErrors.description[index] = "";
    setErrors(updatedErrors);
  };

  const handleFileInputChange = (e) => {
    setSelectedFile(e.target.files[0] || null);
  };

  const handleSaveNewClick = () => {
    if (validateForm()) {
      submitRequest(false);
    }
  };

  const resetForm = () => {
    setSelectedType("");
    setSelectedOrigin("");
    setDescription("");
    setSelectedContacts([]);
    setSelectedOwner(null);
    setFormData([{ partNo: "", qty: "", description: "" }]);
    setRowCount(1);
    setSelectedFile(null);
    setType("");
  };

  const submitRequest = (closeAfter = true) => {
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    setSuccessMessage("");

    const contactsIds = selectedContacts.map((contact) => contact.value);

    const partsRequested =
      type === "Part(s) Exchange" || type === "Part(s) / Consumable Request"
        ? formData.map((part) => ({
            PartNo: part.partNo,
            PartDescription: part.description,
            Qty: part.qty,
          }))
        : [];

    const formDataToSend = new FormData();
    formDataToSend.append("MachineID", machineId);
    formDataToSend.append("Description", description);
    formDataToSend.append("Type", type);
    formDataToSend.append("Origin", "Web");
    formDataToSend.append("Contacts", JSON.stringify(contactsIds));
    formDataToSend.append("ServiceRequestOwner", assignedEngineerId);
    formDataToSend.append("PartRequested", JSON.stringify(partsRequested));
    formDataToSend.append("Email", email);
    if (selectedFile) {
      formDataToSend.append("file", selectedFile);
    }

    console.log("Request Data - MachineID:", machineId, "Type:", type, "Description:", description);

    axios
      .post(
        "/server/jad_group_website_function/create-service-request",
        formDataToSend,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      )
      .then((response) => {
        console.log("Successfully posted data:", response.data);
        setSuccessMessage("Your request has been submitted successfully!");
        resetForm();

        setTimeout(() => {
          setSuccessMessage("");
          if (closeAfter) {
            props.onClose();
            window.location.reload();
          }
        }, 2000);
      })
      .catch((error) => {
        console.error("Error posting data:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const submit_close = () => {
    submitRequest(true);
  };

  async function getContactData(email) {
    try {
      let response = await axios.get(
        `/server/jad_group_website_function/sr-creation-contact?Customer_Email=${email}`
      );
      console.log("Successfully got data:", response.data);
      return response.data.data;
    } catch (error) {
      console.error("Error getting data:", error);
    }
  }

  async function getMachineData(machineId, customerEmail) {
    try {
      let response = await axios.get(
        `/server/jad_group_website_function/sr-creation-machine?MachineID=${machineId}&Customer_Email=${encodeURIComponent(
          customerEmail
        )}`
      );
      console.log("Successfully got machine data:", response.data);
      const assignedEng = response.data.data.find(
        (machine) => machine.id === machineId
      );
      if (assignedEng) {
        setAssignedEngineer(assignedEng.Assigned_Engineer);
        setAssignedEngineerId(assignedEng.Assigned_Engineer_id);
      }
    } catch (error) {
      console.error("Error getting machine data:", error);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const email = sessionStorage.getItem("email");
        const machineId = sessionStorage.getItem("machineId");

        const [contactData, partNoData] = await Promise.all([
          getContactData(email),
          getMachineData(machineId, email),
          axios.get("/server/manufacturer-list/part-number-list-details"),
        ]);

        setContactnamedata(contactData);
        if (partNoData.data && Array.isArray(partNoData.data.part_numbers)) {
          setPartNumbersList(partNoData.data.part_numbers);
        }
        setSelectedContacts(
          contactData.Contacts.map((contact) => ({
            value: contact.id,
            label: `${contact["Contact Name"]}- ${contact.email}`,
          }))
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (props.machineName) {
      setMachineName(props.machineName);
    }
  }, [props.machineName]);

  const typeOptions = [
    { value: "", label: "-None-" },
    { value: "Part(s) Exchange", label: "Part(s) Exchange" },
    { value: "Part(s) / Consumable Request", label: "Part(s) / Consumable(s) Order" },
    { value: "2nd Level Remote Technical Support", label: "2nd Level Remote Technical Support" },
    { value: "On-Site Service Visit", label: "On-Site Service Visit" },
    { value: "Calibration Service", label: "Calibration Service" },
  ];

  const [isTypeOpen, setIsTypeOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsTypeOpen(false);
      }
      if (
        openPartDropdownIndex !== null &&
        partDropdownWrapperRefs.current[openPartDropdownIndex] &&
        !partDropdownWrapperRefs.current[openPartDropdownIndex].contains(event.target)
      ) {
        setOpenPartDropdownIndex(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openPartDropdownIndex]);

  const handleTypeSelect = (value) => {
    setType(value);
    setIsTypeOpen(false);
  };

  const customStyles = {
    multiValue: (provided) => ({
      ...provided,
      display: "contents",
      width: "100%",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      display: "block",
      whiteSpace: "normal",
    }),
  };

  return (
    <div className={showPopup ? "Popup_box" : "d-none"}>
      {isLoading && (
        <div className="popup-overlay">
          <div className="loading-message">Processing...</div>
        </div>
      )}
      {successMessage && (
        <div className="popup-overlay">
          <div className="submitted-message">{successMessage}</div>
        </div>
      )}
      <div className="Inside_popup">
        <h1>Service Request Information</h1>
        <p>A brief description of the service you are requesting.</p>
        <div className="Section_">
          <div className="First_form">
            <div className="Selection_">
              <label>Machine Name</label>
              <input
                type="text"
                value={machineName ? machineName.split("|")[0].trim() : ""}
                readOnly
                className="readonly-field"
              />
            </div>
            <div className="Selection_">
              <label>Type <span className="required-star">*</span></label>
              <div className="custom-dropdown-wrapper" ref={dropdownRef}>
                <div
                  className={`custom-dropdown editable-field ${isTypeOpen ? "open" : ""} ${!type ? "placeholder" : ""}`}
                  onClick={() => setIsTypeOpen(!isTypeOpen)}
                >
                  <span className="custom-dropdown-text">
                    {type ? typeOptions.find((o) => o.value === type)?.label : "-None-"}
                  </span>
                  <span className="custom-dropdown-arrow">{isTypeOpen ? "\u25B2" : "\u25BC"}</span>
                </div>
                {isTypeOpen && (
                  <ul className="custom-dropdown-menu">
                    {typeOptions.map((option, index) => (
                      <li
                        key={index}
                        className={`custom-dropdown-item ${type === option.value ? "selected" : ""}`}
                        onClick={() => handleTypeSelect(option.value)}
                      >
                        {option.label}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            <div
              className="Selection_"
              style={{ display: "none" }}
            >
              <label>Contacts</label>
              <div style={{ width: "435px" }}>
                <Select
                  isMulti
                  value={selectedContacts}
                  onChange={handleContactsChange}
                  options={
                    Servicerequestformdata.Contacts &&
                    Object.keys(Servicerequestformdata).length !== 0 &&
                    Servicerequestformdata.Contacts.map((contact) => ({
                      value: contact.id,
                      label: `${contact["Contact Name"]}- ${contact.Email}`,
                    }))
                  }
                  styles={customStyles}
                />
              </div>
            </div>

            <div className="Selection_">
              <label>Description <span className="required-star">*</span></label>
              <input
                className="placeholder-description editable-field"
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="  Description"
              />
            </div>
          </div>

          <div className="First_form">
            <div className="Selection_">
              <label>Service Request Owner</label>
              <input
                type="text"
                value={assignedEngineer}
                readOnly
                className="readonly-field"
              />
            </div>

            <div style={{ marginTop: "15px" }} className="Selection_">
              <label>Diagnostic/Other Files</label>
              <input
                type="file"
                id="myfile"
                name="myfile"
                className="editable-field"
                onChange={handleFileInputChange}
              />
            </div>
          </div>
        </div>

        {type === "Part(s) Exchange" ||
        type === "Part(s) / Consumable Request" ? (
          <div style={{ paddingBottom: "60px" }}>
            <h1 style={{ margin: "20px 0 10px 0" }}>Part Requested</h1>
            {[...Array(rowCount)].map((_, index) => (
              <div key={index} style={{ position: "relative", zIndex: openPartDropdownIndex === index ? 99999 : 1 }}>
                <div className="First_forms">
                  <div className="Selection_s">
                    <label>Part No.</label>
                    <div
                      className="custom-dropdown-wrapper"
                      style={{ zIndex: openPartDropdownIndex === index ? 99999 : 1 }}
                      ref={(el) => (partDropdownWrapperRefs.current[index] = el)}
                    >
                      <input
                        type="text"
                        placeholder="Enter Part Number"
                        value={formData[index].partNo}
                        onFocus={() => setOpenPartDropdownIndex(index)}
                        onChange={(e) => {
                          handleChange(index, "partNo", e.target.value);
                          setOpenPartDropdownIndex(index);
                        }}
                        className={errors.partNo[index] ? "error editable-field" : "editable-field"}
                      />
                      {openPartDropdownIndex === index && (
                        <ul className="custom-dropdown-menu">
                          {partNumbersList
                            .filter((pNo) =>
                              pNo.toLowerCase().includes((formData[index].partNo || "").toLowerCase())
                            )
                            .slice(0, 100)
                            .map((pNo, pIdx) => (
                              <li
                                key={pIdx}
                                className={`custom-dropdown-item ${formData[index].partNo === pNo ? "selected" : ""}`}
                                onMouseDown={() => {
                                  handleChange(index, "partNo", pNo);
                                  setOpenPartDropdownIndex(null);
                                }}
                              >
                                {pNo}
                              </li>
                            ))}
                          {partNumbersList.filter((pNo) =>
                            pNo.toLowerCase().includes((formData[index].partNo || "").toLowerCase())
                          ).length === 0 && (
                            <li
                              className="custom-dropdown-item"
                              style={{ color: "#999", cursor: "default" }}
                            >
                              No matching part number found
                            </li>
                          )}
                        </ul>
                      )}
                    </div>
                    {errors.partNo[index] && (
                      <span className="error-message">
                        {errors.partNo[index]}
                      </span>
                    )}
                  </div>
                  <div className="Selection_s">
                    <label>Qty</label>
                    <input
                      type="number"
                      placeholder="Enter Qty in Numbers"
                      value={formData[index].qty}
                      onChange={(e) =>
                        handleChange(index, "qty", e.target.value)
                      }
                      className={errors.qty[index] ? "error" : ""}
                    />
                    {errors.qty[index] && (
                      <span className="error-message">{errors.qty[index]}</span>
                    )}
                  </div>

                  <div className="Selection_s">
                    <label>Description</label>
                    <input
                      type="text"
                      placeholder="Enter Text Description"
                      value={formData[index].description}
                      onChange={(e) =>
                        handleChange(index, "description", e.target.value)
                      }
                      className={errors.description[index] ? "error" : ""}
                    />
                    {errors.description[index] && (
                      <span className="error-message">
                        {errors.description[index]}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
            <button className="Create-Service-Request" onClick={handleAddRow}>
              + Add Row
            </button>
          </div>
        ) : null}

        <div className="Submit_button_box">
          <button className="Cancel" onClick={props.onClose}>
            Cancel
          </button>
          <button className="Save_New" onClick={handleSaveNewClick}>
            Save and New
          </button>
          <button className="Save" onClick={submit_close}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupComponent2;
